/**
 * Centralised ThinkChina site identity data for JSON-LD structured data (USF).
 *
 * Consumed by:
 * - src/app/root.tsx (sitewide NewsMediaOrganization via <USFOrgSchema />)
 * - src/app/routes/Home/Home.tsx (<USFWebSiteSchema /> Sitelinks Search Box)
 * - src/app/routes/Article/ArticlePageSEO.tsx (NewsArticle publisher)
 *
 * @see https://sph.atlassian.net/browse/THIN-1570
 */
import type { USFOrgSchemaProps } from "@sphtech/web2-seo-schema";

export const SITE_NAME = "ThinkChina";
export const SITE_URL = "https://www.thinkchina.sg";

// --- Organization ---
export const ORG_DESCRIPTION =
  "ThinkChina - Get latest insights on China through the eyes of global thought leaders & journalists.";

export const ORG_LOGO = {
  url: `${SITE_URL}/favicon-512x512.png`,
  width: 512,
  height: 512,
};

// --- Social media profiles (for sameAs) ---
// Keep in sync with src/app/components/SocialIcons/SocialIcons.tsx
export const ORG_SAME_AS = [
  "https://www.facebook.com/ThinkChina",
  "https://twitter.com/ThinkChinaSG",
  "https://www.instagram.com/thinkchina",
  "https://www.youtube.com/@thinkchinasg",
  "https://www.linkedin.com/company/thinkchinasg",
];

// --- Contact point (required by USFOrgSchema) ---
// TODO(THIN-1570): replace with the official ThinkChina customer service number.
export const ORG_CONTACT_POINT = {
  telephone: "+65-63196319",
  contactType: "customer service",
  availableLanguage: "English",
  areaServed: { name: "Singapore" },
};

export const ORG_SCHEMA_PROPS: USFOrgSchemaProps = {
  name: SITE_NAME,
  description: ORG_DESCRIPTION,
  url: SITE_URL,
  logo: ORG_LOGO,
  sameAs: ORG_SAME_AS,
  contactPoint: ORG_CONTACT_POINT,
};

// --- Search configuration (for USFWebSiteSchema SitelinksSearchBox) ---
export const SEARCH_URL_PATTERN = `${SITE_URL}/search?q={search_term_string}`;

// --- Publisher logo for article schemas ---
export const PUBLISHER_LOGO = ORG_LOGO;
